/* AlignaRest theme — small global helpers */
(function(){
  // Confirm address removal
  document.addEventListener('click', function(e){
    var el = e.target.closest('[data-confirm-delete]');
    if(el){ if(!window.confirm('Remove this address?')){ e.preventDefault(); } }
  });
  // Smooth-scroll for in-page anchors (login/recover toggle, etc.)
  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href^="#"]');
    if(a && a.getAttribute('href').length > 1){
      var t = document.querySelector(a.getAttribute('href'));
      if(t){ e.preventDefault(); t.scrollIntoView({behavior:'smooth', block:'start'}); }
    }
  });
})();
